'use client';

import React from 'react';
import GlassNavbar from '@/components/shared/navbar';
import Footer from '../home/components/footer';
import FullBody from '../home/body';
import Loader from '@/components/shared/Loader';

export default function Loading() {
  return (
    <FullBody
      beforeContent={
        <>
          <GlassNavbar />
          {/* Placeholder for Hero spacing */}
          <div style={{ height: '80px' }} />
        </>
      }
      afterContent={<Footer />}
    >
      <div style={{ position: 'relative', minHeight: '60vh', width: '100%' }}>
        <Loader text="Loading Gallery..." fullscreen={false} />
      </div>
    </FullBody>
  );
}
